export const BOOLEAN_FACET_KEYS = [
  'horseRacingSportsData.form.placed.last1',
  'horseRacingSportsData.form.placed.last3',
  'horseRacingSportsData.form.placed.last6',
  'horseRacingSportsData.handicap',
] as const;
